import { combineReducers } from 'redux'
import UserReducer from './UserReducer'
import ParticipantReducer from './ParticipantReducer'
import ScanReducer from './ScanReducer'
import TransactionReducer from './TransactionReducer'
import ExhibitorReducer from './ExhibitorReducer'
import RaffleReducer from './RaffleReducer'
import PrizeReducer from './PrizeReducer'
import WinnerReducer from './WinnerReducer'
import SettingReducer from './SettingReducer'
import BoothReducer from './BoothReducer'
import ActivityReducer from './ActivityReducer'
import EventReducer from './EventReducer'

const RootReducer = combineReducers({
    user: UserReducer,
    participants: ParticipantReducer,
    scans: ScanReducer,
    transactions: TransactionReducer,
    exhibitors: ExhibitorReducer,
    raffles: RaffleReducer,
    prizes: PrizeReducer,
    winners: WinnerReducer,
    settings: SettingReducer,
    booths: BoothReducer,
    activities: ActivityReducer,
    events: EventReducer

})

export default RootReducer
